import React from 'react';
import clsx from 'clsx';
import {
  makeStyles,
  useTheme,
  Theme,
  createStyles,
} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import useStyles from '../styles';
import { useSidebarIsVisible } from '../../../../redux/reducers/gl_navigation_reducer/selectors';
import { useDispatch } from 'react-redux';
import NavigationActions from '../../../../redux/reducers/gl_navigation_reducer/actions';
import LanguageMenu from '../../../../components/app_common/language_selector';
import { AccountCircle } from '@material-ui/icons';
import LanguageIcon from '@material-ui/icons/Language';
import {
  Badge,
  InputBase,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Configuration, { ProfileConfiguration } from '../configuration';
import { useHistory } from 'react-router';
import MoreIcon from '@material-ui/icons/MoreVert';
import SearchIcon from '@material-ui/icons/Search';
import { Environment } from '../../../../config';
import NavigationConfig from 'navigation/config';
import NotificationActions from 'redux/reducers/notification_reducer/actions';
import * as NotificationSelectors from 'redux/reducers/notification_reducer/selectors';
import { useIsLogin } from 'redux/reducers/gl_auth_reducer/selectors';

const menuLanId = 'primary-lan-account-menu';
const menuId = 'primary-search-account-menu';
const mobileMenuId = 'primary-search-account-menu-mobile';

const AppbarMenu = (props: any) => {
  // console.log('Render AppbarMenu');
  const dispatch = useDispatch();
  const notifications = NotificationSelectors.useGetUnreadNotificationCount();
  const isLogin = useIsLogin();

  React.useEffect(() => {
    if (isLogin) {
      // console.log('IM NOW LOGGEDIN');
      dispatch(NotificationActions.fetchUnreadNotificationCountAction());
    }
  }, [dispatch, isLogin]);

  const classes = useStyles();
  const open = useSidebarIsVisible();

  React.useEffect(() => {
    return () => {
      dispatch(NotificationActions.clearUnreadNotificationCountAction());
    };
  }, []);

  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [lanAnchorEl, setLanAnchorEl] = React.useState<null | HTMLElement>(
    null
  );
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const isLanMenuOpen = Boolean(lanAnchorEl);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLanguageMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setLanAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleLanMenuClose = () => {
    setLanAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show new notifications" color="inherit">
          <Badge badgeContent={0} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      {Configuration.language.enable && (
        <MenuItem onClick={handleLanguageMenuOpen}>
          <IconButton
            aria-label="account of current user"
            aria-controls="primary-search-account-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <LanguageIcon />
          </IconButton>
          <p>Language</p>
        </MenuItem>
      )}
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  const renderLanguageMenu = (
    <LanguageMenu
      handleLanMenuClose={handleLanMenuClose}
      isLanMenuOpen={isLanMenuOpen}
      menuLanId={menuLanId}
      lanAnchorEl={lanAnchorEl}
    />
  );

  const renderProfileMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {ProfileConfiguration.map((props, index: number) => (
        <MenuItem
          style={{ marginLeft: props.submenu ? 5 : 0 }}
          key={index}
          onClick={() => {
            props.action(dispatch, history);
            handleMenuClose();
          }}
        >
          {props.icon && <ListItemIcon>{props.icon}</ListItemIcon>}
          <Typography variant="inherit">{props.label}</Typography>
        </MenuItem>
      ))}
    </Menu>
  );

  return (
    <AppBar
      position="fixed"
      color="secondary"
      className={clsx(classes.appBar, {
        // [classes.appBarShift]: false, //open,
      })}
    >
      <Toolbar>
        {!open ? (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() =>
              dispatch(NavigationActions.setSideMenuVisiblityAction(true))
            }
            edge="start"
            className={clsx(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
        ) : (
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={() =>
              dispatch(NavigationActions.setSideMenuVisiblityAction(false))
            }
            edge="start"
            className={clsx(classes.menuButton)}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography className={classes.title} variant="h6" noWrap>
          {Environment.APP_NAME}
        </Typography>

        {Configuration.search.enable && (
          <div className={classes.search}>
            <div className={classes.searchIcon}>
              <SearchIcon />
            </div>
            <InputBase
              placeholder="Search…"
              classes={{
                root: classes.inputRoot,
                input: classes.inputInput,
              }}
              inputProps={{ 'aria-label': 'search' }}
            />
          </div>
        )}

        <div className={classes.grow} />
        <div className={classes.sectionDesktop}>
          <Tooltip title="Notifications">
            <IconButton
              aria-label="view notifications"
              color="inherit"
              onClick={(event) =>
                (window.location.href =
                  NavigationConfig.notificationsPage().path)
              }
            >
              <Badge
                badgeContent={
                  typeof notifications === 'number' ? notifications : 0
                }
                color="error"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton>
          </Tooltip>
          {Configuration.search.enable && (
            <IconButton
              edge="end"
              aria-label="system languages"
              aria-controls={menuLanId}
              aria-haspopup="true"
              style={{ marginLeft: 10 }}
              onClick={handleLanguageMenuOpen}
              color="inherit"
            >
              <LanguageIcon />
            </IconButton>
          )}
          <IconButton
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            style={{ marginLeft: 10 }}
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            <AccountCircle />
          </IconButton>
        </div>
        <div className={classes.sectionMobile}>
          <IconButton
            aria-label="show more"
            aria-controls={mobileMenuId}
            aria-haspopup="true"
            onClick={handleMobileMenuOpen}
            color="inherit"
          >
            <MoreIcon />
          </IconButton>
        </div>
      </Toolbar>
      {renderMobileMenu}
      {renderLanguageMenu}
      {renderProfileMenu}
    </AppBar>
  );
};

export default AppbarMenu;
